/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconTag = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-tag',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M12.9 23c-.2 0-.392-.03-.575-.087a1.312 1.312 0 0 1-.525-.338L2.425 13.2a1.312 1.312 0 0 1-.337-.525A1.885 1.885 0 0 1 2 12.1V4.5c0-.433.142-.792.425-1.075C2.708 3.142 3.067 3 3.5 3h7.6c.2 0 .4.03.6.087.2.059.383.171.55.338l9.325 9.325c.333.333.5.704.5 1.113 0 .408-.167.779-.5 1.112l-7.6 7.6a1.401 1.401 0 0 1-.487.313A1.6 1.6 0 0 1 12.9 23ZM6.125 8.4c.35 0 .654-.13.912-.388.259-.258.388-.562.388-.912s-.13-.654-.388-.912a1.248 1.248 0 0 0-.912-.388c-.35 0-.654.13-.912.388a1.248 1.248 0 0 0-.388.912c0 .35.13.654.388.912.258.259.562.388.912.388Z" })));
});
IconTag.displayName = 'IconTag';
export default IconTag;
